import { get, toQueryString } from '../axios'
import { paginated } from '../zod/pagination'
import { phoneNumber } from './phone-number'

export function fetchPhoneNumbers(whatsappBusinessAccountId: string) {
    return get(
        paginated(phoneNumber),
        '/phone-numbers?' +
            toQueryString({
                size: 100,
                filters: {
                    whatsappBusinessAccountId: [whatsappBusinessAccountId],
                },
            })
    )
}
